// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportCardChartLegend_root__1F5KN","list":"ReportCardChartLegend_list__3pPx-","listItem":"ReportCardChartLegend_listItem__3rDyj"};